import { defineExperiment } from '@cian/experiments/ab';
import { NEWBUILDING_BOOKING_BANNER_MESSAGING_EXPERIMENT } from 'shared/constants/experiments';

// TODO: Удалить эксперимент по итогам CD-292104.
export const NewbuildingBookingBannerMessagingExperiment = defineExperiment(
  NEWBUILDING_BOOKING_BANNER_MESSAGING_EXPERIMENT,
  {
    groups: ['A', 'B', 'C'] as const,
    default: 'A',
  },
);
